<template>
  <div :class="['mobile-nav', { active: isOpen }]">
    <!-- Logo 区域 -->
    <div class="mobile-nav-header">
      <router-link to="/" class="mobile-logo" @click="$emit('close')">
        <div class="mobile-logo-icon">
          <img :src="logoSrc" alt="Logo" />
        </div>
        <span class="mobile-logo-text">Feedax</span>
      </router-link>
      <button class="mobile-close-btn" @click="$emit('close')">
        <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>

    <!-- 用户信息区域 -->
    <div v-if="userStore.profile" class="mobile-user-section">
      <div class="mobile-user-info">
        <div class="mobile-avatar">
          {{ avatarLetter }}
        </div>
        <div class="mobile-user-detail">
          <span class="mobile-username">{{ userStore.nickname || '用户' }}</span>
          <span class="mobile-email"> {{ userStore.phoneNumber || '未绑定手机' }}</span>
        </div>
      </div>
    </div>

    <!-- 导航链接 -->
    <div class="mobile-nav-links">
      <router-link
        v-if="userStore.profile"
        to="/profile"
        class="mobile-nav-item"
        @click="$emit('close')"
      >
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
        控制台
      </router-link>
    </div>

    <!-- 主题切换 -->
    <div class="mobile-theme-section">
      <div class="mobile-theme-label">
        <svg
          v-if="theme === 'dark'"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
        <svg v-else width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
        <span>主题模式</span>
      </div>
      <div class="mobile-theme-toggle">
        <button :class="['theme-btn', { active: theme === 'light' }]" @click="setTheme('light')">
          <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
          浅色
        </button>
        <button :class="['theme-btn', { active: theme === 'dark' }]" @click="setTheme('dark')">
          <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
            />
          </svg>
          深色
        </button>
      </div>
    </div>

    <!-- 登出/登录 -->
    <div class="mobile-nav-footer">
      <form v-if="userStore.profile" method="post" action="/api/logout" class="logout-form">
        <button class="mobile-logout-btn" type="submit">
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          退出登录
        </button>
      </form>
      <a v-else :href="loginUrl" class="mobile-login-btn" @click="$emit('close')">
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
          />
        </svg>
        登录获取 APIkey
      </a>
    </div>
  </div>
</template>

<script setup>
  import { computed, inject } from 'vue'
  import { useUserStore } from '@/store/modules/user'
  import { useAppStore } from '@/store/modules/app'
  import logoDark from '@/assets/logo.png'
  import logoLight from '@/assets/logo1.png'

  defineProps({
    isOpen: {
      type: Boolean,
      default: false
    }
  })

  const emit = defineEmits(['close'])
  const userStore = useUserStore()
  const appStore = useAppStore()
  const theme = inject('theme')
  const loginUrl = inject('loginUrl')

  const logoSrc = computed(() => {
    return theme.value === 'dark' ? logoDark : logoLight
  })

  const avatarLetter = computed(() => {
    return userStore.nickname?.charAt(0)?.toUpperCase() || 'U'
  })

  const setTheme = (newTheme) => {
    appStore.setTheme(newTheme)
  }
</script>

<style scoped>
  .mobile-nav {
    position: fixed;
    inset: 0;
    background: var(--bg-primary);
    z-index: 999;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .mobile-nav.active {
    transform: translateX(0);
  }

  [data-theme='dark'] .mobile-nav {
    background: var(--bg-primary);
  }

  /* Header */
  .mobile-nav-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--border-color);
    background: var(--bg-secondary);
  }

  .mobile-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
  }

  .mobile-logo-icon {
    width: 32px;
    height: 32px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-logo-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .mobile-logo-text {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
  }

  .mobile-close-btn {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.05);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .mobile-close-btn:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  [data-theme='dark'] .mobile-close-btn {
    background: rgba(255, 255, 255, 0.1);
  }

  [data-theme='dark'] .mobile-close-btn:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  .mobile-close-btn svg {
    color: var(--text-secondary);
  }

  /* User Section */
  .mobile-user-section {
    padding: 20px;
    background: linear-gradient(135deg, rgba(79, 70, 241, 0.08), rgba(139, 92, 246, 0.08));
    border-bottom: 1px solid var(--border-color);
  }

  [data-theme='dark'] .mobile-user-section {
    background: linear-gradient(135deg, rgba(79, 70, 241, 0.15), rgba(139, 92, 246, 0.15));
  }

  .mobile-user-info {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .mobile-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f46e5, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 700;
    font-size: 18px;
  }

  .mobile-user-detail {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .mobile-username {
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
  }

  .mobile-email {
    font-size: 13px;
    color: var(--text-secondary);
  }

  /* Nav Links */
  .mobile-nav-links {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .mobile-nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    color: var(--text-primary);
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    border-radius: 12px;
    transition: all 0.2s ease;
  }

  .mobile-nav-item:hover {
    background: rgba(99, 102, 241, 0.1);
    color: var(--primary);
  }

  .mobile-nav-item svg {
    color: var(--text-secondary);
  }

  .mobile-nav-item:hover svg {
    color: var(--primary);
  }

  .mobile-nav-item.router-link-active {
    background: rgba(99, 102, 241, 0.15);
    color: var(--primary);
  }

  .mobile-nav-item.router-link-active svg {
    color: var(--primary);
  }

  /* Theme Section */
  .mobile-theme-section {
    padding: 16px 20px;
    margin: 8px 12px;
    background: var(--card-bg);
    border-radius: 16px;
    border: 1px solid var(--border-color);
  }

  .mobile-theme-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-secondary);
    margin-bottom: 12px;
  }

  .mobile-theme-label svg {
    color: var(--text-secondary);
  }

  .mobile-theme-toggle {
    display: flex;
    gap: 8px;
  }

  .theme-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    border-radius: 10px;
    background: transparent;
    border: 1px solid var(--border-color);
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .theme-btn:hover {
    border-color: var(--primary);
  }

  .theme-btn.active {
    background: linear-gradient(135deg, rgba(79, 70, 241, 0.15), rgba(139, 92, 246, 0.15));
    border-color: var(--primary);
    color: var(--primary);
  }

  .theme-btn.active svg {
    color: var(--primary);
  }

  /* Footer */
  .logout-form {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  .mobile-nav-footer {
    padding: 16px 20px;
    margin-top: auto;
    border-top: 1px solid var(--border-color);
  }

  .mobile-logout-btn,
  .mobile-login-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 14px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .mobile-logout-btn {
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.3);
    color: #ef4444;
  }

  .mobile-logout-btn:hover {
    background: rgba(239, 68, 68, 0.15);
  }

  .mobile-login-btn {
    background: linear-gradient(135deg, #4f46e5, #4338ca);
    border: none;
    color: white;
    text-decoration: none;
    box-shadow: 0 4px 15px rgba(79, 70, 229, 0.3);
  }

  .mobile-login-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(79, 70, 229, 0.4);
  }
</style>
